/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IEquipmentIP } from 'app/shared/model/equipment-ip.model';
import { IPaymentScheme } from 'app/shared/model/payment-scheme.model';
import { ChargeType } from 'app/shared/model/enumerations/charge-type.model';

export interface IEquipmentIPCharges {
  id?: string;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  price?: number;
  maxDiscount?: number;
  chargeType?: keyof typeof ChargeType | null;
  multiplierApplied?: boolean;
  startDate?: number;
  endDate?: number | null;
  suspended?: boolean;
  draft?: boolean;
  equipment?: IEquipmentIP | null;
  scheme?: IPaymentScheme | null;
}

export const defaultValue: Readonly<IEquipmentIPCharges> = {
  active: false,
  multiplierApplied: false,
  suspended: false,
  draft: false,
};
